export default __webpack_public_path__ + "static/media/f.7a3c619b.svg";